module.exports = require('react/lib/ReactCSSTransitionGroup');


/** WEBPACK FOOTER **
 ** node_modules/react-addons-css-transition-group/index.js
 **/